import { render, staticRenderFns } from "./MsButton.vue?vue&type=template&id=3f24325e&scoped=true&lang=html"
import script from "./MsButton.vue?vue&type=script&lang=js"
export * from "./MsButton.vue?vue&type=script&lang=js"
import style0 from "./MsButton.vue?vue&type=style&index=0&id=3f24325e&prod&lang=scss&scoped=true"
import style1 from "./MsButton.vue?vue&type=style&index=1&id=3f24325e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f24325e",
  null
  
)

export default component.exports